/* HEECH ring options. The paid service is a real Shopify product, linked to its ring in the cart. */
(() => {
  const root = () => window.Shopify?.routes?.root || '/';

  function requestFor(form, formData) {
    const options = form.querySelector('heech-ring-options');
    if (!options) return null;

    const toggle = options.querySelector('[data-engraving-toggle]');
    if (!toggle?.checked) return null;

    const textInput = options.querySelector('[data-engraving-text]');
    const engravingText = textInput?.value.trim() || '';
    if (!engravingText) {
      textInput?.setCustomValidity('Enter the engraving text.');
      textInput?.reportValidity();
      throw new Error('Enter the engraving text.');
    }
    textInput.setCustomValidity('');

    const ringId = Number(formData.get('id'));
    const serviceId = Number(toggle.dataset.variantId);
    if (!Number.isSafeInteger(ringId) || !Number.isSafeInteger(serviceId) || ringId === serviceId) {
      throw new Error('Engraving is temporarily unavailable. Please contact us.');
    }

    const properties = {};
    for (const [key, value] of formData.entries()) {
      const match = /^properties\[(.+)\]$/.exec(key);
      if (match && String(value).trim()) properties[match[1]] = value;
    }
    properties.Engraving = engravingText;

    const ring = { id: ringId, quantity: 1, properties };
    if (formData.get('selling_plan')) ring.selling_plan = formData.get('selling_plan');
    const service = {
      id: serviceId,
      quantity: 1,
      parent_id: ringId,
      properties: {
        _heech_service: 'engraving',
        'For': options.dataset.productTitle || 'Ring',
        'Engraving': engravingText
      }
    };
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [ring, service],
        sections: formData.get('sections') || '',
        sections_url: formData.get('sections_url') || ''
      })
    };
  }

  async function findEngravingVariant(toggle) {
    const initialId = Number(toggle.dataset.variantId);
    if (Number.isSafeInteger(initialId) && initialId > 0 &&
        Number(toggle.dataset.variantPrice) === 12000 && toggle.dataset.variantAvailable === 'true') {
      return initialId;
    }
    for (const handle of ['ring-engraving', 'heech-ring-engraving']) {
      try {
        const response = await fetch(`${root()}products/${handle}.js`, { credentials: 'same-origin' });
        if (!response.ok) continue;
        const service = await response.json();
        const variant = service.variants?.find(item => item.available && Number(item.price) === 12000);
        if (variant?.id) return Number(variant.id);
      } catch (_) {
        // A missing handle or blocked product endpoint is handled below.
      }
    }
    return null;
  }

  async function changeQuantity(lineKey, quantity, sections) {
    const cart = await (await fetch(`${root()}cart.js`)).json();
    const target = cart.items.find(item => item.key === lineKey);
    const attached = cart.items.find(item => item.parent_relationship?.parent_key === lineKey && item.properties?._heech_service === 'engraving');
    const endpoint = `${root()}cart/change.js`;
    const change = (key, count, renderSections) => fetch(endpoint, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: count, sections: renderSections ? sections.join(',') : '' })
    });

    if (!target || !attached) return change(lineKey, quantity, true);
    const first = await change(lineKey, quantity, true);
    if (!first.ok || quantity === 0) return first;
    const current = await first.clone().json();
    const child = current.items.find(item => item.key === attached.key);
    if (!child || child.quantity === quantity) return first;
    return change(child.key, quantity, true);
  }

  function initialize(element) {
    const toggle = element.querySelector('[data-engraving-toggle]');
    if (!toggle) return;
    const fields = element.querySelector('[data-engraving-fields]');
    const text = element.querySelector('[data-engraving-text]');
    const status = element.querySelector('[data-engraving-status]');
    const update = () => {
      fields.hidden = !toggle.checked;
      text.disabled = !toggle.checked;
      text.required = toggle.checked;
      if (!toggle.checked) text.setCustomValidity('');
    };
    toggle.addEventListener('change', update);
    text.addEventListener('input', () => text.setCustomValidity(''));
    update();
    findEngravingVariant(toggle).then(id => {
      if (!element.isConnected) return;
      if (id) {
        toggle.dataset.variantId = String(id);
        toggle.disabled = false;
        if (status) status.hidden = true;
      } else if (status) {
        status.textContent = 'Engraving is temporarily unavailable. Please contact us.';
        status.hidden = false;
      }
    });
  }

  if (!customElements.get('heech-ring-options')) {
    customElements.define('heech-ring-options', class extends HTMLElement {
      connectedCallback() { initialize(this); }
    });
  }
  window.HeechPersonalization = { requestFor, changeQuantity, findEngravingVariant };
})();
